import { ApolloClient } from '@apollo/client';
import { PostSubcategory } from '../../domain/postCategories';
import { Content, fetchPostsWithAds, fetchVideos } from './fetchPostsData';
import { resolved } from '../../utility/promiseHelper';
import { fifthInEverySix } from '../../ads/adPlacementLogic';

export const fetchLocationInsightLandingPageData = async (
  client: ApolloClient<unknown>,
  excludePostIds: number[],
) => {
  const locationInsightLandingPageRequirement = {
    locationInsight: 6,
    featuredVideos: 3,
  };

  const [locationInsightData, videoData] = await Promise.allSettled([
    fetchPostsWithAds(
      client,
      locationInsightLandingPageRequirement.locationInsight,
      0,
      {
        postCategory: [PostSubcategory.LocationInsight],
      },
      fifthInEverySix,
      excludePostIds,
    ),
    fetchVideos(client, locationInsightLandingPageRequirement.featuredVideos, {
      postCategory: [PostSubcategory.LocationInsight],
    }),
  ]);

  const defaultContents = { contents: [] as Content[], hasMore: false };
  return {
    locationInsight: resolved(locationInsightData, defaultContents).contents,
    video: resolved(videoData, { featuredVideos: [], heroVideo: null }),
  };
};

export const fetchLocationInsightSubLandingPageData = async (
  client: ApolloClient<unknown>,
  excludePostIds: number[],
  tag: string,
) => {
  const locationInsightLandingPageRequirement = {
    locationInsight: 6,
    featuredVideos: 3,
  };

  const [locationInsightData, videoData] = await Promise.allSettled([
    fetchPostsWithAds(
      client,
      locationInsightLandingPageRequirement.locationInsight,
      0,
      {
        postCategory: [PostSubcategory.LocationInsight],
        tag,
      },
      fifthInEverySix,
      excludePostIds,
    ),
    fetchVideos(client, locationInsightLandingPageRequirement.featuredVideos, {
      postCategory: [PostSubcategory.LocationInsight],
      tag,
    }),
  ]);

  const defaultContents = { contents: [] as Content[], hasMore: false };
  return {
    locationInsight: resolved(locationInsightData, defaultContents).contents,
    video: resolved(videoData, { featuredVideos: [], heroVideo: null }),
  };
};
